import { call } from '@advanza/api'
import { SelectCheckbox } from '@advanza/input'
import { useAppDispatch, useAppSelector } from 'hooks/hooks'
import React, { useEffect } from 'react'

const PlatformsSelect = ({ ...rest }) => {
    const dispatch = useAppDispatch()
    const { isFetchingPlatforms, hasFetchedPlatforms, platforms } = useAppSelector(
        (state) => state.providers.platforms,
    )
    useEffect(() => {
        if (isFetchingPlatforms || hasFetchedPlatforms) {
            return
        }
        dispatch({ type: 'PLATFORMS_REQUEST' })
        call('office/providers-platforms/get-platforms').then(
            ({ platforms }) =>
                dispatch({
                    type: 'PLATFORMS_RECEIVE',
                    platforms: Array.isArray(platforms) ? {} : platforms,
                }),
            () => dispatch({ type: 'PLATFORMS_RECEIVE' }),
        )
    }, [dispatch, hasFetchedPlatforms, isFetchingPlatforms])

    return (
        <SelectCheckbox
            options={Object.keys(platforms).map((id) => {
                return {
                    value: parseInt(id),
                    name: platforms[id],
                }
            })}
            placeholder="platforms"
            {...rest}
        />
    )
}

export default PlatformsSelect
